import { FC, PropsWithChildren } from 'react';

/** @deprecated */
const OptionsDropdown: FC<PropsWithChildren<{}>> = ({ children }) => {
  return <div className='overflow-hidden rounded-lg bg-white'>{children}</div>;
};

export default OptionsDropdown;
